import myaxios from "../../components/Axios";

export const createLeadService = ({ data }) => myaxios.post(`/ajax/lead`, data)
export const getSingleLeadService = ({ id, expand }) => myaxios.get(`/ajax/lead/${id}?expand=${expand}`)
export const updateLeadService = ({ id, data }) => myaxios.put(`/ajax/lead/${id}`, data)
export const deleteLeadService = ({ id }) => myaxios.delete(`/ajax/lead/${id}`)
export const getLeadPrepareService = (prepare_id) => myaxios.get(`/ajax/lead/prepare?sales_funnel_id=${prepare_id}`)
export const getLeadListService = ({ expand = "", filter = "", sort = "" }) => myaxios.get(`/ajax/lead/`)

export const leadConvertService = ({ id, data }) => myaxios.post(`/ajax/lead/${id}/convert`, data)